module.exports = __webpack_public_path__ + "img/supbg2.3de51fc1.jpg";